import React from 'react';
import { Collapse } from 'antd';
import { tv } from 'tailwind-variants';
import { CollapseCommonProps } from 'types';
import { CaretUp } from '@phosphor-icons/react';
import type { CollapseProps } from 'antd';

const collapse = tv({
  base: 'bg-white p-6 my-3 shadow-custom',
  variants: {
    size: {
      md: 'rounded-md',
      xl: 'rounded-2xl',
      sm: 'rounded-none p-0',
    },
  },
  defaultVariants: {
    size: 'xl',
  },
});

const CollapseCommon: React.FC<
  CollapseCommonProps & {
    hideExpandIcon?: boolean;
    disableCollapse?: boolean;
  }
> = ({
  title = '',
  children,
  defaultActive = true,
  positionIcon = 'end',
  collapseKey,
  size,
  className = '',
  hideExpandIcon = false,
  disableCollapse = false,
}) => {
  const collapseClass = `${collapse({ size })} ${className}`;

  const items: CollapseProps['items'] = [
    {
      key: collapseKey,
      label: <h1 className='text-[15px] 2xl:text-xl 2xl:leading-6'>{title}</h1>,
      children,
    },
  ];

  return (
    <Collapse
      defaultActiveKey={defaultActive ? [collapseKey] : []}
      ghost
      expandIconPosition={positionIcon}
      expandIcon={
        hideExpandIcon
          ? () => null
          : ({ isActive }) => (
              <CaretUp
                size={20}
                className='transition-transform duration-500 ease-in-out'
                style={{
                  transform: isActive ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
                onClick={(e) => {
                  if (disableCollapse) e.stopPropagation();
                }}
              />
            )
      }
      className={collapseClass}
      items={items.map((item) => ({
        ...item,
        label: (
          <div
            onClick={(e) => {
              if (disableCollapse) e.stopPropagation();
            }}
          >
            {item.label}
          </div>
        ),
      }))}
    />
  );
};

export default CollapseCommon;
